import React from 'react'
import { Charts, MainCard, PageHeader, UserTable } from '../../components'

import './home.css'

const Home = () => {
  return (
    <>
      <title>Dashboard</title>
      <PageHeader title="Dashboard" description="Welcome to the dashboard" download="Download Report" />

      <MainCard />

      <div className='charts-main-wrapper'>
        <Charts />
      </div>

      <div className='workers-main-wrapper-double'>
        <UserTable />
        <UserTable />
      </div>

      {/* <div className='workers-main-wrapper-triple'>
        
      </div> */}

      <div className='workers-main-wrapper-single'>
        Enrollment Table
      </div>

      <div className='workers-main-wrapper-single'>
        {/* <AdminsTable /> */}
      </div>
    </>
  )
}

export default Home